import { render, staticRenderFns } from "./InstrumentRiskModal.vue?vue&type=template&id=4d5f635e&scoped=true"
import script from "./InstrumentRiskModal.vue?vue&type=script&lang=ts"
export * from "./InstrumentRiskModal.vue?vue&type=script&lang=ts"
import style0 from "./InstrumentRiskModal.vue?vue&type=style&index=0&id=4d5f635e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5f635e",
  null
  
)

export default component.exports